import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CancelIcon from '@mui/icons-material/Cancel';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'; // or another appropriate package
import { faVolleyball } from '@fortawesome/free-solid-svg-icons';
import { IconButton, Tooltip, TableCell, TextField } from '@mui/material';
import { Grid, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';

function AdvanceBookingIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [customerName, setCustomerName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [dateOfJoining, setDateOfJoining] = useState('');
    const [remarks, setRemarks] = useState('');
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    // const [amount, setAmount] = useState('0');
    const [cautionamount, setCautionamount] = useState('');
    const [rentamount, setRentamount] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        const fetchtableData = async () => {


        };

        fetchtableData();
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        fetchtableData();
        setLoading(true);
    }, []);
    // .catch((error) => {
    //     console.error('Error fetching Customer Details:', error);
    // });


    // const fetchtableData = async () => {
    //     fetchData('AdvanceBookingApi', `/AdvanceBookingdetails/${companyId}`, token)
    //         .then((response) => {
    //             if (response.responseCode == '1111') {
    //                 console.log(response);
    //                 setData(response.response_data);
    //             }
    //         })

    //     .catch (error) {
    //         console.error('Error fetching Sales Details:', error);
    //     }
    //     finally {
    //         setLoading(false); // Hide loading screen
    //     }

    // };
    const fetchtableData = async () => {
        try {
            setLoading(true); // Show loading screen
            const response = await fetchData('AdvanceBookingApi', `/AdvanceBookingdetails/${companyId}`, token);

            if (response.responseCode === '1111') {
                console.log(response);
                setData(response.response_data);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Advance Booking Details:', error);
        } finally {
            setLoading(false); // Hide loading screen
        }
    };


    const [roomTypeOptions, setRoomTypeOptions] = useState([]);
    const [selectedRoomType, setSelectedRoomType] = useState("");
    const [selectedRoomRent, setSelectedRoomRent] = useState("");
    const [roomName, setRoomName] = useState([]);

    // Fetch room types
    const fetchRoomTypes = async () => {
        try {
            const response = await fetchData('RoomApi', `/${companyId}`, token);

            if (response.responseCode === '1111') {
                const options = response.response_data.map(rooms => ({
                    value: rooms.ID,
                    label: rooms.Name
                }));
                setRoomName(response.response_data);
                setRoomTypeOptions(options);
            }

            console.log(response);
        } catch (error) {
            console.error('Error fetching Room Types:', error);
        }
    };



    const handleroomChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedRoomType(selectedOption.value);
        }
    };


    // Fetch room types on component mount
    useEffect(() => {
        fetchRoomTypes();
    }, []);

    const handleDelete = async () => {
        deleteData('AdvanceBookingApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('AdvanceBookingApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData();
            })
            .catch((error) => {
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    function formatDate(dateString) {
        if (!dateString) {
            return '';
        }

        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    function isExpired(dateString) {
        const currentDate = new Date();
        const date = new Date(dateString);
        return date < currentDate;
    }

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const closeModal = () => {
        console.log('Closing modal');
        setOpen(false);
    };



    const [Confirmopen, setConfirmOpen] = useState(false);

    const handleClickConfirmOpen = () => {
        setOpen(true);
    };

    const handleClickConfirmClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        try {
            const BookingData = {
                CompanyId: companyId,
                RoomId: selectedRoomType,
                Name: customerName,
                ContactNo: contactNumber,
                DateOfJoining: dateOfJoining,
                BookingRemark: remarks,
                CautionDeposut: cautionamount,
                RentAmount: rentamount,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('AdvanceBookingApi', BookingData, token)
                .then((response) => {
                    console.log('Customer Created success:', response);

                    setSuccessMessages("Customer Created successfully!");
                    setErrorMessages("");
                    window.location.reload();

                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '95%' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>ADVANCE BOOKING</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
                <Tooltip title="Advance Booking">

                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        style={{
                            background: 'linear-gradient(to right, red, red)',
                            color: 'white',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '35px',
                        }}
                        onClick={handleClickOpen}

                    >
                        Booking
                    </Button>

                </Tooltip>
            </div>
            <Modal open={open} className={open ? 'notification-modal' : ''}>
                <div className="fixed inset-0 flex items-start justify-center z-10">
                    <div className="p-4 sm:p-6 rounded-lg shadow-lg w-full sm:w-3/4 md:w-2/3 lg:w-1/2" style={{ maxHeight: '80vh', overflowY: 'auto', marginTop: '50px', background: 'white' }}>

                        <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>ADVANCE BOOKING</h6>
                        <div className="flex justify-end mt-2">
                            <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-10px', color: 'black' }}>
                                <Tooltip title="Close">
                                    <FaTimes />
                                </Tooltip>
                            </button>
                        </div>

                        <div className="mt-4">
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Customer Name"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                </Grid>
                                <Grid container item spacing={2} xs={12}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            margin="dense"
                                            label="Contact Number"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            value={contactNumber}
                                            onChange={(e) => setContactNumber(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            margin="dense"
                                            label="Date of Joining"
                                            type="date"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            variant="outlined"
                                            value={dateOfJoining}
                                            onChange={(e) => setDateOfJoining(e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item spacing={2} xs={12}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl variant="outlined" fullWidth margin="dense">
                                            <InputLabel>Room</InputLabel>
                                            <Select
                                                value={selectedRoomType}
                                                onChange={(e) => setSelectedRoomType(e.target.value)}
                                                label="Room"
                                            >
                                                {roomTypeOptions.map(option => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            margin="dense"
                                            label="Caution Amount"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            value={cautionamount}
                                            onChange={(e) => setCautionamount(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            margin="dense"
                                            label="Rent Amount"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            value={rentamount}
                                            onChange={(e) => setRentamount(e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        margin="dense"
                                        label="Remarks"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <DialogActions>
                            <Button onClick={handleClose} color="error">
                                Close
                            </Button>
                            <Button onClick={handleSubmit} color="primary">
                                Submit
                            </Button>
                        </DialogActions>
                    </div>
                </div>
            </Modal>



            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <button
                        onClick={closeConfirmDialog}
                        style={{
                            backgroundColor: '#dc3545',
                            color: '#ffffff',
                            border: '1px solid #dc3545',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                            marginRight: '8px',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        style={{
                            backgroundColor: '#28a745',
                            color: '#ffffff',
                            border: '1px solid #28a745',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                        }}
                    >
                        Confirm
                    </button>
                </DialogActions>

            </Dialog>
            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'darkblue' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white' }}>Sl.No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white' }}>Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white' }}>Room</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white' }}>Remarks</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white' }}>DateOfJoining</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '5px', color: 'white', textAlign: 'center' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.Id}>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.Name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.ContactNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.RoomName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{item.BookingRemark}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '13px' }}>{formatDate(item.DateOfJoining)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '13px' }}>


                                        {!item.IsBooked && (
                                            <Button
                                                variant="contained"
                                                style={{
                                                    marginRight: '8px',
                                                    background: 'linear-gradient(to right, darkgreen, darkgreen)',
                                                    borderRadius: '50px',
                                                    padding: '10px 20px',
                                                    color: 'white',
                                                    fontWeight: 'bolder',
                                                    textTransform: 'none',
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                                    height: '30px'
                                                }}
                                                component={Link} to={`/ConfirmCustomer/${item.Id}`}
                                            >
                                                Confirm
                                            </Button>
                                        )}

                                        {!item.IsBooked && (
                                            <Button
                                                variant="contained"
                                                style={{
                                                    marginRight: '8px',
                                                    background: 'linear-gradient(to right, darkred, darkred)',
                                                    borderRadius: '50px',
                                                    padding: '10px 20px',
                                                    color: 'white',
                                                    fontWeight: 'bolder',
                                                    textTransform: 'none',
                                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                                    height: '30px'
                                                }}
                                                onClick={() => openConfirmDialog(item.Id)}

                                            >
                                                Cancel
                                            </Button>
                                        )}


                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to Cancel this Booking?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div >
        </div >
    );
}

export default AdvanceBookingIndex;

